import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
    static values = { messages: Array };

    declare hasMessagesValue: boolean;
    readonly messagesValue!: { type: string, text: string }[];

    connect() {
        if (!this.hasMessagesValue) return;

        this.messagesValue.forEach(msg => {
            if (msg.type === 'success') {
                toastr.success(msg.text);
            } else if (msg.type === 'error') {
                toastr.error(msg.text);
            } else {
                toastr.info(msg.text);
            }
        });
    }
}
